export const FIELDS = {
  ADVANCE_PAYMENT: 'advancePayment'
};
